import {
  SCHEDULED,
  RECEIVED_STATUS,
  CONFIRMATION_STATUS,
  LIVE_PROCESS_STATUS,

  CURATION_STATUS,
  DELIVERY_METHOD
} from 'domains/seller-inbound/constants'
import { SELLER_TYPE } from 'domains/seller/constants/seller-constants'
import {
  InputSelectOptions
} from 'components/molecules'
import { BRAND_CLASSIFICATION } from 'domains/seller-product/constants'

// * Overwrite the key value to be more consistent with other status labels
const SCHEDULE_LABEL = Object.freeze({
  [SCHEDULED.YES] : 'Scheduled',
  [SCHEDULED.NO]  : 'Pending'
})

export const sellerInboundsTextInputFields = [
  {
    name        : 'code',
    label       : 'Code',
    placeholder : 'Search by Inbound Code'
  },
  {
    name        : 'seller_name',
    label       : 'Seller Name',
    placeholder : 'Search by Seller Name'
  },
  {
    name        : 'seller_code',
    label       : 'Seller Code',
    placeholder : 'Search by Seller Code'
  },
  {
    name        : 'seller_email',
    label       : 'Seller Email',
    placeholder : 'Search by Seller Email'
  },
  {
    name        : 'seller_mobile',
    label       : 'Seller Mobile',
    placeholder : 'Search by Seller Mobile'
  },
  {
    name        : 'notes',
    label       : 'Notes',
    placeholder : 'Search by Notes'
  }
]

export const sellerInboundsSelectInputFields = [
  {
    name     : 'delivery_method',
    label    : 'Delivery Method',
    children : <InputSelectOptions options={ DELIVERY_METHOD } />
  },
  {
    name     : 'live_process_status',
    label    : 'Live Process Status',
    children : <InputSelectOptions options={ LIVE_PROCESS_STATUS } />
  },
  {
    name     : 'confirmation_status',
    label    : 'Confirmation Status',
    children : <InputSelectOptions options={ CONFIRMATION_STATUS } />
  },
  {
    name     : 'received_status',
    label    : 'Received Status',
    children : <InputSelectOptions options={ RECEIVED_STATUS } />
  },
  {
    name     : 'pickup_scheduled',
    label    : 'Scheduled',
    children : (<>
      <option key='' value=''>Choose one</option>
      {
        Object.keys(SCHEDULED).map((key) => {
          const value = SCHEDULED[key]
          return (
            <option
              key={ `dropoff-location-option-${value}` }
              value={ value }
              className='text-capitalize'
            >
              { SCHEDULE_LABEL[value] }
            </option>
          )
        })
      }
    </>)
  },
  {
    name     : 'tl_brand_classification_name',
    label    : 'Brand Classification',
    children : <InputSelectOptions options={ BRAND_CLASSIFICATION } />
  },
  {
    name     : 'seller_type',
    label    : 'Seller Type',
    children : <InputSelectOptions options={ SELLER_TYPE } />
  },
  {
    name     : 'curation_status',
    label    : 'Curation Status',
    children : <InputSelectOptions options={ CURATION_STATUS } />
  }
]

export const sellerInboundsDateInputFields = [
  {
    name  : 'requested_date',
    label : 'Requested Date'
  },
  {
    name  : 'received_date',
    label : 'Received Date'
  },
  {
    name  : 'pickup_scheduled_date',
    label : 'Scheduled Date'
  }
]
